export default __webpack_public_path__ + "static/media/squared_plus.dc325e5b.svg";